function GetOrigin() {
    return window.location.origin.toString();
}

export default {
    GetOrigin
};